import { render, staticRenderFns } from "./UserAddReport.vue?vue&type=template&id=59589c84&scoped=true"
import script from "./UserAddReport.vue?vue&type=script&lang=js"
export * from "./UserAddReport.vue?vue&type=script&lang=js"
import style0 from "./UserAddReport.vue?vue&type=style&index=0&id=59589c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59589c84",
  null
  
)

export default component.exports